import { privateInstance } from 'services/axios/privateInstance'
import {
  API_CREATE_CHANGE_LOG_ENTRY,
  API_DELETE_CHANGE_LOG_ENTRY,
  API_GET_CHANGE_LOG_ENTRIES,
  API_GET_CHANGE_LOG_ENTRY,
  API_GET_CHANGE_LOG_HISTORY,
  API_GET_CHANGE_LOG_ROLES,
  API_GET_CHANGE_LOG_UNSEEN,
  API_MARK_CHANGE_LOG_SEEN,
  API_UPDATE_CHANGE_LOG_ENTRY,
} from 'constants/apiUrl'
import { IChangeLogDetailed, IChangeLogForm, IChangeLogHistoryItem, IChangeLogListItem } from 'typescript/interfaces/changeLog'
import { AxiosResponse } from 'axios'
import { generatePath } from 'react-router-dom'

export const getChangeLogRoles = () => privateInstance.get<void, AxiosResponse<Array<string>>>(API_GET_CHANGE_LOG_ROLES)

export const getChangeLogEntries = () => privateInstance.get<void, AxiosResponse<Array<IChangeLogListItem>>>(API_GET_CHANGE_LOG_ENTRIES)

export const getChangeLogEntry = (id: number) =>
  privateInstance.get<number, AxiosResponse<IChangeLogDetailed>>(generatePath(API_GET_CHANGE_LOG_ENTRY, { id }))

export const createChangeLogEntry = (values: IChangeLogForm) =>
  privateInstance.post<IChangeLogForm, AxiosResponse<IChangeLogDetailed>>(API_CREATE_CHANGE_LOG_ENTRY, values)

export const updateChangeLogEntry = ({ id, values }: { id: number; values: IChangeLogForm }) =>
  privateInstance.put<IChangeLogForm, AxiosResponse<IChangeLogDetailed>>(generatePath(API_UPDATE_CHANGE_LOG_ENTRY, { id }), values)

export const deleteChangeLogEntry = (id: number) =>
  privateInstance.delete<number, AxiosResponse<boolean>>(generatePath(API_DELETE_CHANGE_LOG_ENTRY, { id }))

export const getChangeLogHistory = () =>
  privateInstance.get<void, AxiosResponse<Array<IChangeLogHistoryItem>>>(API_GET_CHANGE_LOG_HISTORY)

export const getUnseenChangeLogEntry = () =>
  privateInstance.get<void, AxiosResponse<IChangeLogHistoryItem | ''>>(API_GET_CHANGE_LOG_UNSEEN)

export const markChangeLogEntrySeen = (id: number) =>
  privateInstance.post<number, AxiosResponse<void>>(generatePath(API_MARK_CHANGE_LOG_SEEN, { id }))
